import { render, staticRenderFns } from "./PackageViewGlobal.vue?vue&type=template&id=752a7241"
import script from "./PackageViewGlobal.vue?vue&type=script&lang=js"
export * from "./PackageViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports